export const AppointmentStatus = {
  CREATED: "CREATED",
  CANCELLED: "CANCELLED",
  CONFIRMED: "CONFIRMED",
  FULFILLED: "FULFILLED"
};



// WEBPACK FOOTER //
// ./src/features/subscriptions/modules/appointments/models/AppointmentStatus.js